import Vue from 'vue'
import { Button, Form, FormItem, Input, Checkbox, CheckboxButton, Message, Carousel, CarouselItem, Dropdown, DropdownItem, DropdownMenu, MessageBox, Breadcrumb, BreadcrumbItem, Tabs, TabPane, Pagination, Link, Icon, Notification, Popover, Menu, MenuItem, Submenu, Select, Option, Radio, Table, TableColumn, Dialog, Tooltip, RadioGroup, Col, DatePicker, TimePicker, CheckboxGroup, Cascader } from 'element-ui'
Vue.use(Button).use(Form).use(FormItem).use(Input).use(Checkbox).use(CheckboxButton).use(Carousel).use(CarouselItem).use(Dropdown).use(DropdownItem).use(DropdownMenu).use(Breadcrumb).use(BreadcrumbItem).use(Tabs).use(TabPane).use(Pagination).use(Link).use(Icon).use(Popover).use(Menu).use(MenuItem).use(Submenu).use(Select).use(Option).use(Radio).use(Table).use(TableColumn).use(Dialog).use(Tooltip).use(RadioGroup).use(Col).use(DatePicker).use(TimePicker).use(CheckboxGroup).use(Cascader)


// 解决页面刷洗自动弹出空白提示框问题
let VuePrototype = Vue.prototype
Message.install = function () {
    VuePrototype.$notify = Notification
}



Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;